import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateLicenseTypeRequest,
  FetchDefaultPrefixRequest,
} from '../license-types.actions'
import { getCreateLicenseTypeState } from '../license-types.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-create-license-type',
  templateUrl: './create-license-type.component.html',
  styleUrls: ['./create-license-type.component.css'],
})
export class CreateLicenseTypeComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createLicenseType'))
    this.store.dispatch(new FetchDefaultPrefixRequest())
    this.state$ = this.store
      .pipe(select(getCreateLicenseTypeState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createLicenseType.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createLicenseType',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      codePrefix: 'required|max:5',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      codePrefix: 'code prefix',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateLicenseTypeRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createLicenseType',
        ),
      )
    }
  }
}
